import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "general"
    }}>{`General`}</h2>
    <Accordion mdxType="Accordion">
      <AccordionItem header="How do I purchase and what’s the cost?" isChevronIcon mdxType="AccordionItem">
        <p>{`The Photoshop API is currently availabe for Enterprise use. Please reach out to your Adobe Account Manager for more information. `}</p>
      </AccordionItem>
      <AccordionItem header="What kind of storage can I work with?" isChevronIcon mdxType="AccordionItem">
        <p>{`You can retrieve and store files from any storage that provides pre-signed urls. We recommend S3 from Amazon Web Services, Dropbox, and Azure but any pre-signed url should work.`}</p>
      </AccordionItem>
      <AccordionItem header="Is all of Photoshop available?" isChevronIcon mdxType="AccordionItem">
        <p>{`While all features are not available, with the release of the Photoshop Actions endpoint you now have access to any operation that does not require user input.`}</p>
      </AccordionItem>
      <AccordionItem header="How can I provide feedback or ask questions?" isChevronIcon mdxType="AccordionItem">
        <p>{`Please reach out to `}<a parentName="p" {...{
            "href": "mailto:psdservices@adobe.com"
          }}>{`psdservices@adobe.com`}</a>{` or leave a post in our `}<a parentName="p" {...{
            "href": "https://community.adobe.com/t5/photoshop-developers/ct-p/ct-photoshop-developers?page=1&sort=latest_replies&lang=all&tabid=all"
          }}>{`community forum`}</a>{`.
We’re happy to hear from you!`}</p>
      </AccordionItem>
    </Accordion>
    <h2 {...{
      "id": "account-management"
    }}>{`Account Management`}</h2>
    <Accordion mdxType="Accordion">
      <AccordionItem header="How do I see how many API transactions or calls I've used?" isChevronIcon mdxType="AccordionItem">
        <p>{`For Adobe Enterprise Terms Licensing Agreement (ETLA) customers, you will receive monthly emails on your usage.
For AWS Customers, you can log into your marketplace dashboard to view your bill.`}</p>
      </AccordionItem>
      <AccordionItem header="My company has an existing Enterprise Agreement with Adobe. Can I use the same Adobe credentials to sign up for the Photoshop API free trial?" isChevronIcon mdxType="AccordionItem">
        <p>{`Your Adobe Admin Console admin may have not provisioned your Enterprise ID to have access to the Photoshop API. If your organization is a current subscriber and receiving an error, contact your administrator to have the grant you a developer role.`}</p>
        <p>{`If you are interested in using Adobe Photoshop API on a trial basis, consider using an Adobe ID (Personal) that is not tied to your enterprise ID.`}</p>
      </AccordionItem>
      <AccordionItem header="Why do I have to use a personal account when setting up a trial or account? Why can't I use my company's existing enterprise email/account?" isChevronIcon mdxType="AccordionItem">
        <p>{`Access to Adobe Photoshop APIs or SDK is only available when it is attached to an Enterprise Term License Agreement (ETLA) and the organization's IT administrator has provisioned that user to have access to the API. For this reason, if you are working on a trial basis, it may be easier and faster to use a personal email than your existing Adobe ID.`}</p>
      </AccordionItem>
      <AccordionItem header="Where do I find my Client ID or API key?" isChevronIcon mdxType="AccordionItem">
        <p>{`Your Client ID (also known as API key) is unique to your account and provided on the successful trial creation confirmation page. This is the "client_id" key used in the back-end code to make free trial calls against. You can also log into the developer console by clicking here (insert link).`}</p>
      </AccordionItem>
      <AccordionItem header="If I already have credentials and need new ones, how do I get them?" isChevronIcon mdxType="AccordionItem">
        <p>{`Both paid and trial customers can create new credentials, as well as edit existing credentials, by going to the Adobe Developer Console: `}<a href="https://developer.adobe.com/console"><a parentName="p" {...{
              "href": "https://developer.adobe.com/console"
            }}>{`https://developer.adobe.com/console`}</a></a>{`.`}</p>
      </AccordionItem>
      <AccordionItem header="Can I continue using my same trial credentials after I sign up for paid access to the Adobe Photoshop API?" isChevronIcon mdxType="AccordionItem">
        <p>{`You should not use your free trial credentials (Credential Key aka API Key) beyond your trial.`}</p>
        <p>{`When you start your Enterprise Term Licensing Agreement (ETLA), you will receive & create new credentials under your ETLA ORG–you will want to exchange your free trial credentials with those new ETLA credentials.`}</p>
      </AccordionItem>
    </Accordion>
    <h2 {...{
      "id": "billing"
    }}>{`Billing`}</h2>
    <Accordion mdxType="Accordion">
      <AccordionItem header="How does billing work and what counts as an API call?" isChevronIcon mdxType="AccordionItem">
        <p>{`Users are billed based on API Transactions, where one billable transaction is equal to one successful API call.`}</p>
      </AccordionItem>
      <AccordionItem header="Do I still get charged if an api call returns any errors?" isChevronIcon mdxType="AccordionItem">
        <p>{`No. You are not charged for Failures and Errors (4XX or 5XX response from the service). Polling calls to check status of an async call are also not billed.`}</p>
      </AccordionItem>
      <AccordionItem header="Are there any usage limits?" isChevronIcon mdxType="AccordionItem">
        <p>{`  As of June 1st all free trial customers will get 500 calls to use over the course of a year. Users subscribed via the AWS Marketplace are billed on a monthly usage-based model and there are no limits to the amount of calls you can make in a billing cycle. Enterprise subscription usage limits are defined contractually on a case-by-case basis.`}</p>
      </AccordionItem>
      <AccordionItem header="Are there any throttle limits?" isChevronIcon mdxType="AccordionItem">
        <p>{`Each API endpoint has its own unique limitations to be aware of. Please see the API documentation for additional details.`}</p>
      </AccordionItem>
      <AccordionItem header="Can I use the API if I am not in the United States?" isChevronIcon mdxType="AccordionItem">
        <p>{`Our international(non U.S) subscription is available for purchase from billing addresses within the following list of allowed countries only:`}</p>
        <p>{`India, Indonesia, Malaysia, South Africa, Japan, Austria, Belgium, Bulgaria, Canada, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Isle of Man, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovakia, Slovenia, Spain, Sweden, and UK.`}</p>
        <p>{`We may have other options to purchase Adobe Photoshop API for customers in countries that are not included on this list. Please see our pricing page for available purchase options or feel free to contact us for more information.`}</p>
      </AccordionItem>
    </Accordion>
    <br />
    <br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      